export const getRandomCalories = () => {
  return '999';
};
